// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__24za-","title":"Header_title__3Q6vk","headerButton":"Header_headerButton__UHC8_"};